import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants } from "../../src/utils";

const {
  htmlElement: { LINK_SPAN },
  helperAttributes: { NUMBERED_CITATION },
} = CkeditorConstants;

export default class CutCommand extends Command {
  refresh() {
    // Listens when entire document is selected via CTRL + A or Select ALL button
    const selectAll = this.editor.commands.get('selectAll');
    selectAll.on('execute', () => {
      this.selected = !this.selected;
      this.enableButton();
    });

    // Listens when already removed text is retrieved with Undo operation [ Retrieved text will be selected here ]
    const undoCommand = this.editor.commands.get('undo');
    undoCommand.on('execute', () => {
      this.selected = true;
      this.selectedMediaProperties = false;
      this.enableButton();
    });
    this.enableButton();
  }

execute() {
  const selection = window.getSelection();
  const node = selection?.anchorNode;
  // ✅ GET CURRENT EDITOR ROOT
  const editorElement = this.editor.ui.view.editable.element;
  // ✅ VALIDATE SELECTION BELONGS TO THIS EDITOR
  if (!editorElement.contains(node)) {
    return;
  }
  
  // ✅ SAFE TO CUT
  document.execCommand('cut');

  this.isEnabled = false;
}

  enableButton() {
    const editor = this.editor;
    const selection = editor.model.document.selection;
    const selectedElement = selection.getSelectedElement();
    const selectedBlocks = [...selection.getSelectedBlocks()];
    if (
      selectedElement &&
      selectedElement.name &&
      (selectedElement.name.includes("image") || selectedElement.name.includes("figureTag") ||
        selectedElement.name.includes("table"))
    ) {
      this.selected = true;
    }

    // Enable / Disable Cut button
    /**
     * Checks if user has selected more than one elements then check for selectedBlocks length
     */
    this.isEnabled =
     ((window.getSelection().toString() || this.selected || (selectedElement?.name === NUMBERED_CITATION)) && 
     !this.isReadOnly &&
     selectedBlocks.length <= 1) || this.selected || (selectedElement?.name === NUMBERED_CITATION) ||
     (selectedBlocks.length > 1 && selectedBlocks.some(item => item.name === LINK_SPAN));
    this.selected = false;
  }
}
